import { consumeService } from "./Utils/Service"

export const getNews = async date => {
  
  return await consumeService({
    url: `api/v1/news?filtros=${encodeURIComponent(JSON.stringify(date))}`,
    method: 'GET'
  })
}